import { CANDIDATE_COPY } from '../../bewerbende/copy'

/**
 * Bewerbenden-Infopage als Showcase. Inhalte wie in der Cinematic-Version,
 * dazu ein paar Zeilen für die neuen Szenen.
 */

const de = {
  ...CANDIDATE_COPY.de,
  show: {
    kicker: 'Für Bewerbende',
    stepLabel: 'Schritt',
    realApp: 'Echte Aufnahmen aus der Aivy-App',
    fairKicker: 'Fair für alle',
    tipsKicker: 'Bevor du startest',
    appPhones: ['Spiele', 'Stärkenprofil', 'Perspektiven']
  }
}

const en = {
  ...CANDIDATE_COPY.en,
  show: {
    kicker: 'For candidates',
    stepLabel: 'Step',
    realApp: 'Real recordings from the Aivy app',
    fairKicker: 'Fair for everyone',
    tipsKicker: 'Before you start',
    appPhones: ['Games', 'Strengths profile', 'Perspectives']
  }
}

export const SHOW_CANDIDATE_COPY = { de, en }
